import { BackgroundCard, ButtonCTA, PageDivider } from '@davies-group/white-label-ui/ui';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';
import { Box, Typography } from '@mui/material';

import ConfirmDialog from '../../components/ConfirmDialog';
import CustomerDocuments from '../../components/CustomerDocuments';
import { useDocumentUpload } from '../../context/DocumentUploadContext';
import { useHandleNavigation } from '../../hooks';
import { useDocumentRequestService } from '../../services';
import { applicationSettings } from '../../utils';
import completedPage from '../Completed';
import errorPage from '../Error';
import { IPage } from '..';

const ClientUpload = () => {
    const { state, dispatch } = useDocumentUpload();
    const { navigate } = useHandleNavigation();
    const [confirmOpen, setConfirmOpen] = React.useState<boolean>(false);
    const documentRequestService = useDocumentRequestService();

    React.useEffect(() => {
        if (state.isCompleted) {
            navigate(completedPage, state.requestId ?? applicationSettings.invalidRequestId);
        }
    }, [navigate, state.isCompleted, state.requestId]);

    const updateDocument = () => {
        documentRequestService
            .completeDocumentRequest(state.documentRequest.id)
            .then(() => {
                dispatch({ type: 'updateIsCompleted' });
                navigate(completedPage, state.requestId ?? applicationSettings.invalidRequestId);
            })
            .catch((err) => {
                dispatch({ type: 'updateError', payload: err.message });
                navigate(errorPage, state.requestId ?? applicationSettings.invalidRequestId);
            });
    };

    return (
        <BackgroundCard>
            <ConfirmDialog title="Uploaded all the requested documents?" open={confirmOpen} setOpen={setConfirmOpen} onConfirm={updateDocument}>
                <Typography color="secondary" align="left" variant="h6">
                    Are you sure you have uploaded all the requested documents? Once you have sent these documents you will not be able to upload any more.
                </Typography>
            </ConfirmDialog>
            <Box px={4}>
                <Typography color="secondary" align="left" variant="h4">
                    <ReactMarkdown>{(state.documentRequest.heading?.length ?? 0) === 0 ? 'Welcome to Davies E-Claims' : state.documentRequest.heading ?? ''}</ReactMarkdown>
                </Typography>
            </Box>
            <PageDivider />
            <Box px={4}>
                <Typography align="left" variant="h2">
                    <ReactMarkdown>{(state.documentRequest.subHeading?.length ?? 0) === 0 ? 'Thank you for choosing to upload your documents online' : state.documentRequest.subHeading ?? ''}</ReactMarkdown>
                </Typography>
            </Box>

            {state.documentRequest.documents?.map((d) => (
                <CustomerDocuments key={`Customer-Document-${d.id}`} document={d} />
            ))}

            <Box p={4} width={1} display="flex" justifyContent="flex-end" alignItems="flex-end">
                <ButtonCTA onClick={() => setConfirmOpen(true)}>Send</ButtonCTA>
            </Box>
        </BackgroundCard>
    );
};

const uploadPage: IPage = {
    title: 'Upload',
    route: {
        path: '/:requestId/upload',
        element: <ClientUpload />,
    },
};

export default uploadPage;
